// extracted by mini-css-extract-plugin
export default {"numberCircle":"NumberCircle_numberCircle__F2bq8"};